import { Separator } from '@ais-ui/ui-core';
import { WMSForm } from './WMSForm';
import { useLocalization } from '@ais-ui/locale-management';

export function SettingsWMSPage() {
  const { messages } = useLocalization();
  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">{messages.settingsWmsTitle}</h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsWmsSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <WMSForm />
    </div>
  );
}
